import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalRequestAccessModalFooter = props => {
  const {
    onCancel,
    onSend,
    sendButtonDisabled
  } = props;
  return /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "product-approvals-request-access-submit-button",
      disabled: sendButtonDisabled,
      use: "primary",
      onClick: onSend,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.sendRequest"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: onCancel,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.cancel"
      })
    })]
  });
};
export default ApprovalRequestAccessModalFooter;